import api from '@/api';
import {vendorApiServer, vendorApiToken} from '@/config';

const myMessage = () => api.get('/b2c/messages');
const myPlans = () => api.get('/b2c/plans');

// for local dev, need to prepare proxy_pass at nginx level or it will have CORs issue:
// https://athena-best.cccdihk.com/
const formDownload = formData =>
  api.get(`${vendorApiServer}/api/public/front/operation-procedure/b2c/list`, {
    params: formData,
    headers: {
      'cccrm-client-secret-key': vendorApiToken,
    },
  });

export {myMessage, myPlans, formDownload};
